/**
 * Define períodos das copas
 */

const cups = {
  // Olimpíadas
  1908: ['19081019', '19081024'],
  1912: ['19120629', '19120704'],
  1920: ['19200828', '19200905'],
  1924: ['19240525', '19240609'],
  1928: ['19280527', '19280613'],
  // Copas
  1930: ['19300713', '19300730'],
  1934: ['19340527', '19340610'],
  1938: ['19380604', '19380619'],
  1950: ['19500624', '19500716'],
  1954: ['19540616', '19540704'],
  1958: ['19580608', '19580629'],
  1962: ['19620530', '19620617'],
  1966: ['19660711', '19660730'],
  1970: ['19700531', '19700621'],
  1974: ['19740613', '19740707'],
  1978: ['19780601', '19780625'],
  1982: ['19820613', '19820711'],
  1986: ['19860531', '19860629'],
  1990: ['19900608', '19900708'],
  1994: ['19940617', '19940717'],
  1998: ['19980610', '19980712'],
  2002: ['20020531', '20020630'],
  2006: ['20060609', '20060709'],
  2010: ['20100611', '20100711'],
  2014: ['20140612', '20140713'],
  2018: ['20180614', '20180715'],
};

const matches = [
  [2, '18730308', ['ENG', 4, 8], ['SCO', 2, -8]],
  [1, '18721130', ['SCO', 0, 0], ['ENG', 0, 0]],
  [6, '18760325', ['SCO', 4, 16], ['WAL', 0, -9]],
  [20, '18820218', ['EIR', 0, -16], ['ENG', 13, 0]],
  [42, '18851128', ['USA', 0, -5], ['CAN', 1, 5]],
  [145, '19020720', ['URU', 0, -11], ['ARG', 6, 11]],
  [146, '19021012', ['AUT', 5, 10], ['HUN', 0, -10]],
  [160, '19040501', ['BEL', 3, 0], ['FRA', 3, 0]],
  [170, '19050430', ['BEL', 1, -9], ['HOL', 4, 9]],
  [204, '19080405', ['SUI', 5, -1], ['GER', 3, -8]],
  [222, '19081024', ['DEN', 0, 53], ['ENG', 2, 207]],
  [340, '19120704', ['ENG', 4, 246], ['DEN', 2, 100]],
  [414, '19140920', ['ARG', 3, 27], ['BRA', 0, -8]],
  [415, '19140927', ['BRA', 1, -2], ['ARG', 0, 21]],
  [444, '19160717', ['ARG', 0, 56], ['URU', 0, 72]],
  [477, '19171014', ['ARG', 0, 86], ['URU', 1, 125]],
  [511, '19190529', ['BRA', 1, 85], ['URU', 0, 94]],
  [558, '19200828', ['NOR', 3, -11], ['ENG', 1, 40]],
  [564, '19200831', ['BEL', 3, 93], ['HOL', 0, 53]],
  [567, '19200902', ['BEL', 2, 134], ['TCH', 0, 87]],
  [835, '19240606', ['URU', 2, 235], ['HOL', 1, 71]],
  [838, '19240609', ['URU', 3, 267], ['SUI', 0, 106]],
  [1153, '19280529', ['ARG', 11, 213], ['USA', 2, -21]],
  [1159, '19280602', ['ARG', 6, 232], ['BEL', 3, -24]],
  [1156, '19280530', ['HOL', 0, -1], ['URU', 2, 228]],
  [1160, '19280603', ['URU', 4, 252], ['GER', 1, 36]],
  [1166, '19280606', ['ARG', 6, 262], ['EGY', 0, 37]],
  [1167, '19280607', ['URU', 3, 268], ['ITA', 2, 109]],
  [1170, '19280610', ['URU', 1, 268], ['ARG', 1, 262]],
  [1172, '19280613', ['URU', 2, 293], ['ARG', 1, 237]],
  [1334, '19300726', ['ARG', 6, 321], ['USA', 1, 56]],
  [1336, '19300730', ['URU', 4, 279], ['ARG', 2, 264]],
  [1632, '19340527', ['SWE', 3, 146], ['ARG', 2, 148]],
  [1643, '19340610', ['ITA', 2, 269], ['TCH', 1, 141]],
  [1993, '19380619', ['BRA', 4, 142], ['SWE', 2, 43]],
  [1989, '19380616', ['BRA', 1, 98], ['ITA', 2, 246]],
  [1992, '19380619', ['HUN', 2, 201], ['ITA', 4, 291]],
  [2831, '19500629', ['ENG', 0, 141], ['USA', 1, -31]],
  [2845, '19500713', ['ESP', 1, 109], ['BRA', 6, 351]],
  [2846, '19500716', ['BRA', 1, 301], ['URU', 2, 127]],
  [3114, '19530401', ['BRA', 2, 163], ['PAR', 3, 147]],
  [3215, '19531125', ['ENG', 3, 141], ['HUN', 6, 141]],
  [3265, '19540523', ['HUN', 7, 147], ['ENG', 1, 142]],
  [3293, '19540620', ['GER', 3, 124], ['HUN', 8, 254]],
  [3303, '19540630', ['URU', 2, 197], ['HUN', 4, 333]],
  [3305, '19540704', ['GER', 3, 307], ['HUN', 2, 298]],
  [3751, '19570707', ['BRA', 1, 160], ['ARG', 2, 264]],
  [3891, '19580608', ['BRA', 3, 209], ['AUT', 0, 84]],
  [3904, '19580611', ['ENG', 0, 164], ['BRA', 0, 205]],
  [3910, '19580615', ['URS', 0, 126], ['BRA', 2, 245]],
  [3918, '19580619', ['BRA', 1, 261], ['WAL', 0, 59]],
  [3922, '19580624', ['BRA', 5, 304], ['FRA', 2, 154]],
  [3925, '19580629', ['SWE', 2, 181], ['BRA', 5, 344]],
  [4538, '19620602', ['TCH', 0, 209], ['BRA', 0, 234]],
  [4564, '19620617', ['BRA', 3, 345], ['TCH', 1, 193]],
  [5459, '19660712', ['BRA', 2, 205], ['BUL', 0, 28]],
  [5478, '19660719', ['BRA', 1, 104], ['POR', 3, 207]],
  [5489, '19660726', ['ENG', 2, 265], ['POR', 1, 206]],
  [5491, '19660730', ['ENG', 4, 315], ['GER', 2, 252]],
  [6473, '19700617', ['BRA', 3, 351], ['URU', 1, 156]],
  [6476, '19700621', ['ITA', 1, 245], ['BRA', 4, 394]],
  [7614, '19740615', ['HOL', 2, 174], ['URU', 0, 43]],
  [7622, '19740619', ['HOL', 0, 168], ['SWE', 0, 111]],
  [7642, '19740703', ['BRA', 0, 260], ['HOL', 2, 342]],
  [7649, '19740707', ['GER', 2, 377], ['HOL', 1, 312]],
  [8884, '19780621', ['ARG', 6, 270], ['PER', 0, 92]],
  [8888, '19780625', ['ARG', 3, 320], ['HOL', 1, 255]],
  [10291, '19820623', ['NZL', 0, -7], ['BRA', 4, 330]],
  [10308, '19820702', ['ARG', 1, 148], ['BRA', 3, 356]],
  [10305, '19820629', ['ITA', 2, 156], ['ARG', 1, 174]],
  [10313, '19820705', ['ITA', 3, 202], ['BRA', 2, 310]],
  [10317, '19820708', ['POL', 0, 199], ['ITA', 2, 253]],
  [10320, '19820711', ['GER', 1, 257], ['ITA', 3, 305]],
  [11961, '19860613', ['DEN', 2, 263], ['GER', 0, 141]],
  [11970, '19860618', ['DEN', 1, 191], ['ESP', 5, 233]],
  [11965, '19860616', ['ARG', 1, 204], ['URU', 0, 39]],
  [11974, '19860622', ['ENG', 1, 193], ['ARG', 2, 236]],
  [11980, '19860629', ['ARG', 3, 295], ['GER', 2, 201]],
  [12592, '19880621', ['GER', 1, 206], ['HOL', 2, 218]],
  [12598, '19880625', ['URS', 0, 222], ['HOL', 2, 260]],
  [13579, '19900608', ['ARG', 0, 27], ['CMR', 1, 126]],
  [13627, '19900701', ['ENG', 3, 225], ['CMR', 2, 96]],
  [13605, '19900618', ['ARG', 1, 88], ['ROM', 1, 139]],
  [13618, '19900624', ['BRA', 0, 250], ['ARG', 1, 134]],
  [13628, '19900703', ['ITA', 1, 274], ['ARG', 1, 151]],
  [13632, '19900708', ['ARG', 0, 133], ['GER', 1, 313]],
  [15215, '19930829', ['COL', 4, 165], ['PER', 0, -126]],
  [15221, '19930905', ['ARG', 0, 161], ['COL', 5, 223]],
  [15599, '19940622', ['USA', 2, 86], ['COL', 1, 121]],
  [15610, '19940626', ['COL', 2, 176], ['SUI', 0, 145]],
  [15644, '19940710', ['ROM', 2, 189], ['SWE', 2, 226]],
  [15647, '19940713', ['ITA', 2, 297], ['BUL', 1, 178]],
  [15650, '19940716', ['SWE', 4, 256], ['BUL', 0, 126]],
  [15646, '19940713', ['BRA', 1, 337], ['SWE', 0, 204]],
  [15651, '19940717', ['ITA', 0, 300], ['BRA', 0, 334]],
  [18236, '19980711', ['HOL', 1, 277], ['CRO', 2, 304]],
  [18231, '19980707', ['BRA', 1, 385], ['HOL', 1, 311]],
  [18237, '19980712', ['BRA', 0, 325], ['FRA', 3, 398]],
  [19753, '20000702', ['ITA', 1, 277], ['FRA', 2, 385]],
  [20655, '20010610', ['JPN', 0, 206], ['FRA', 1, 389]],
  [21283, '20020531', ['FRA', 0, 296], ['SEN', 1, 195]],
  [21293, '20020603', ['TUR', 1, 109], ['BRA', 2, 183]],
  [21320, '20020611', ['DEN', 2, 262], ['FRA', 0, 227]],
  [21346, '20020622', ['SEN', 0, 191], ['TUR', 1, 229]],
  [21352, '20020629', ['KOR', 2, 188], ['TUR', 3, 239]],
  [21352, '20020629', ['KOR', 2, 188], ['TUR', 3, 239]],
  [21276, '20020525', ['MAS', 0, -9], ['BRA', 4, 155]],
  [21351, '20020626', ['BRA', 1, 357], ['TUR', 0, 208]],
  [21353, '20020630', ['GER', 0, 302], ['BRA', 2, 400]],
  [24605, '20060701', ['BRA', 0, 354], ['FRA', 1, 341]],
  [24613, '20060709', ['FRA', 1, 372], ['ITA', 1, 375]],
  [26423, '20080629', ['GER', 0, 285], ['ESP', 1, 365]],
  [27951, '20100616', ['SUI', 1, 191], ['ESP', 0, 319]],
  [28002, '20100707', ['ESP', 1, 425], ['GER', 0, 364]],
  [28006, '20100711', ['HOL', 0, 395], ['ESP', 1, 455]],
  [29854, '20120701', ['ESP', 4, 420], ['ITA', 0, 224]],
  [31569, '20140623', ['ESP', 3, 253], ['AUS', 0, 55]],
  [31516, '20140606', ['SRB', 0, 94], ['BRA', 1, 396]],
  [31593, '20140704', ['BRA', 2, 415], ['COL', 1, 308]],
  [31598, '20140708', ['BRA', 1, 351], ['GER', 7, 480]],
  [31602, '20140712', ['HOL', 3, 437], ['BRA', 0, 304]],
  [31603, '20140713', ['GER', 1, 500], ['ARG', 0, 345]],
  [32465, '20150627', ['BRA', 1, 280], ['PAR', 1, 60]],
  [33345, '20160612', ['PER', 1, 109], ['BRA', 0, 209]],
  [34560, '20171114', ['ENG', 0, 243], ['BRA', 0, 327]],
];
